import { Head } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Manage", href: "/admin/retention" },
  { title: "Retention Policy", href: "/admin/retention" },
]

export default function Index() {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Retention Policy" />

      <div className="p-6">
        <h1 className="border-hpi-light-gray mb-6 border-b pb-2 text-2xl font-semibold">
          Retention Policy
        </h1>

        <section className="mb-6">
          <h2 className="mb-2 text-lg font-semibold">
            Delete 30 days after case is closed
          </h2>
          <ul className="list-disc pl-6">
            <li>
              Subjects: Sensitive Data - SSN, Criminal, Education, Employment,
              Vehicles
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 text-lg font-semibold">
            Delete 1 year after case is closed
          </h2>
          <ul className="list-disc pl-6">
            <li>
              Purge Deleted: Cases, Case Updates, Contacts, Documents, Evidence,
              Expenses, GPS Entries, Reports, Schedule Entries, Subjects, Time
            </li>
            <li>Restricted Notes</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 text-lg font-semibold">
            Delete 2 years after case is closed or pending case last changed
          </h2>
          <ul className="list-disc pl-6">
            <li>Case Photos &amp; Documents</li>
            <li>Subjects: DoB, Photos</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 text-lg font-semibold">
            Delete 7 years after case is closed or pending case last changed
          </h2>
          <ul className="list-disc pl-6">
            <li>Case Contacts</li>
            <li>Case Objectives</li>
            <li>Case Reports</li>
            <li>Case Updates</li>
            <li>Evidence Entries</li>
            <li>GPS Entries</li>
            <li>Schedule Entries</li>
            <li>Time &amp; Expense Entries, including Receipts</li>
            <li>
              Subjects: Address History, Contacts, Criminal History, Education,
              Employment History, Vehicles
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 text-lg font-semibold">
            Not deleted unless case is purged:
          </h2>
          <ul className="list-disc pl-6">
            <li>
              Case: case name, case type, date opened, date closed, client, rep
            </li>
            <li>Subjects: name, aliases</li>
          </ul>
        </section>
      </div>
    </AppLayout>
  )
}
